export class ServiceController {
	public static LOBBY_CONTROLLER = "api/gamelobby/";
	public static PLAYER_CONTROLLER = "api/player/";
	public static RETAIL_AGENT = "api/retailAgent/";
	public static TRANSACTION = "api/transaction/";
	public static AGENT_STATISTICS = "api/statistics/";
}
